import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { NgxCurrencyModule } from 'ngx-currency';
import { NgxMaskModule } from 'ngx-mask';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { NgxSpinnerModule } from 'ngx-spinner';

import { environment } from 'src/environments/environment';

import { ReactiveFormsModule } from '../../node_modules/@angular/forms';
import { Broadcaster } from './../utils/broadcaster.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AuthGuard } from './guard/auth.guard';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { SocketProvider } from './helpers/socket';
import { AuthModule } from './modules/auth/auth.module';
import { AuthService } from './modules/auth/auth.service';

import { NZ_I18N, pt_BR } from 'ng-zorro-antd/i18n'
import localeBr from '@angular/common/locales/br';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeBr, 'br');
import { CKEditorModule } from 'ngx-ckeditor';

// ngx socket config
declare var config: any;

const socketConfig: SocketIoConfig = { url: environment.SOCKET_URL, options: {} };

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    RouterModule,
    AuthModule,
    NgxMaskModule,
    HttpClientModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    NgxCurrencyModule,
    NgxSpinnerModule,
    NgbModule.forRoot(),
    NgxMaskModule.forRoot(),
    SocketIoModule.forRoot(socketConfig),
    NgZorroAntdModule,
    AppRoutingModule,
    CKEditorModule
  ],
  entryComponents:[],
  providers: [
    AuthGuard,
    AuthService,
    SocketProvider,
    { provide: NZ_I18N, useValue: pt_BR },
    Broadcaster,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
